import React from 'react'
import Store from '@Store'
import '@fontsource/poppins/400.css'
import '@fontsource/poppins/400-italic.css'

export const wrapRootElement = ({ element }) => <Store>{element}</Store>
